import gsap from "gsap";
import { debounce } from "lodash";

export class Global {
	constructor() {
		this.subMenu = document.querySelectorAll(".gnb__menu--pc .sub-menu");

		this.gnbPc();
		this.gnbMobile();
		this.setVh();
	}

	// 모바일 고정 높이를 위해 처음 1vh값을 고정하는 함수
	setVh() {
		document.documentElement.style.setProperty("--vh", (window.innerHeight / 100) * 1 + "px");
	}

	// gnb 모바일 애니메이션 관련 함수
	gnbMobile() {
		const hambugerEl = document.querySelector(".hamburger");
		const hamburgerLineEls = hambugerEl.querySelectorAll(".hamburger__line");

		const containerEl = document.querySelector(".gnb__menu-container");
		const itemEls = gsap.utils.toArray(containerEl.querySelectorAll(".gnb__menu--mobile > .menu-item"));

		const HAMBURGER_GUTTER = 8;
		const gnbTl = gsap.timeline({ paused: true });

		gsap.set(containerEl, {
			y: "-100%",
			opacity: 0,
			display: "none",
		});
		gsap.set(".gnb__bottom-menu", {
			opacity: 0,
		});
		itemEls.forEach((item) => {
			gsap.set(item, {
				y: -100,
				opacity: 0,
			});
		});

		hamburgerLineEls.forEach((el, index) => {
			gsap.set(el, {
				y: index * HAMBURGER_GUTTER - HAMBURGER_GUTTER,
			});
			gnbTl.to(
				el,
				{
					y: 0,
					rotate: -45 * index + 135,
				},
				"<"
			);
		});
		gnbTl.to(
			hamburgerLineEls[1],
			{
				scale: 0,
			},
			"<"
		);
		gnbTl.to(
			".gnb__menu-container",
			{
				y: 0,
				opacity: 1,
				display: "flex",
			},
			"<"
		);
		itemEls.forEach((item) => {
			gnbTl.to(
				item,
				{
					y: 0,
					opacity: item.classList.contains("current-menu-item") ? 1 : 0.7,
				},
				"<0.125"
			);
		});
		gnbTl.to(".gnb__bottom-menu", {
			opacity: 1,
		});
		gnbTl.reverse();

		hambugerEl.addEventListener("click", (e) => {
			gnbTl.reversed(!gnbTl.reversed());
		});
	}

	// 모든 sub-menu를 순환하여 sub-menu--active를 제거
	removeSubMenu() {
		this.subMenu.forEach((element) => {
			element.classList.remove("sub-menu--active");
		});
	}
	// gnb PC 서브메뉴 애니메이션
	gnbPc() {
		const menus = document.querySelectorAll(".gnb__menu--pc > .menu-item");
		menus.forEach((menu) => {
			menu.addEventListener(
				"mouseenter",
				(e) => {
					this.removeSubMenu();
					const target = e.target;
					if (target.classList.contains("menu-item-has-children")) {
						target.querySelector(".sub-menu").classList.add("sub-menu--active");
					}
				},
				false
			);
		});
		document.querySelector(".gnb__container--pc").addEventListener("mouseleave", () => {
			this.removeSubMenu();
		});
	}
}
